document.addEventListener('DOMContentLoaded', function() {
  // Fix for the mobile burger menu
  function fixMobileMenu() {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    // Ensure that mainDetailsToggle exists and is correctly set up
    const mainDetailsToggle = headerDrawer.querySelector('details');
    if (!mainDetailsToggle) return;

    // Find the burger menu button (summary)
    const burgerButton = mainDetailsToggle.querySelector('summary');
    if (!burgerButton) return;

    // Remove existing event listeners and add a new one
    const newBurgerButton = burgerButton.cloneNode(true);
    burgerButton.parentNode.replaceChild(newBurgerButton, burgerButton);

    // Add an explicit click event listener for the burger button
    newBurgerButton.addEventListener('click', function(event) {
      event.preventDefault();

      if (mainDetailsToggle.hasAttribute('open')) {
        // Close the menu
        mainDetailsToggle.removeAttribute('open');
        mainDetailsToggle.classList.remove('menu-opening');
        newBurgerButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove(`overflow-hidden-tablet`);
        document.body.classList.remove(`overflow-hidden-desktop`);

        // If there is a header, remove the class
        const header = document.querySelector('.section-header');
        if (header) {
          header.classList.remove('menu-open');
        }
      } else {
        // Open the menu
        mainDetailsToggle.setAttribute('open', '');
        setTimeout(() => {
          mainDetailsToggle.classList.add('menu-opening');
        }, 10);
        newBurgerButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add(`overflow-hidden-tablet`);

        // If there is a header, add the class
        const header = document.querySelector('.section-header');
        if (header) {
          header.classList.add('menu-open');
        }

        // Set the viewport height for correct display on mobile
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    });

    // Handle nested submenus
    fixSubmenuToggle(headerDrawer);
  }

  // Function to fix the operation of nested submenus
  function fixSubmenuToggle(container) {
    // Find all details elements inside the menu (except the main/parent one)
    const submenuDetails = container.querySelectorAll('.menu-drawer__menu details');

    submenuDetails.forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      // Replace event listeners for each submenu
      const newSummary = summary.cloneNode(true);
      summary.parentNode.replaceChild(newSummary, summary);

      newSummary.addEventListener('click', function(event) {
        event.preventDefault();

        if (details.hasAttribute('open')) {
          // Close the submenu
          closeSubmenu(details);
        } else {
          // Open the submenu
          openSubmenu(details);
        }
      });
    });

    // Find all "back" buttons in the submenus
    const backButtons = container.querySelectorAll('.menu-drawer__close-button');
    backButtons.forEach(button => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', function(event) {
        event.preventDefault();

        // Find the parent submenu
        const parentDetails = this.closest('details');
        if (parentDetails) {
          closeSubmenu(parentDetails);
        }
      });
    });
  }

  // Function to open a submenu
  function openSubmenu(details) {
    // Find the parent menu to add the submenu-open class
    const parentMenu = details.closest('.has-submenu');
    if (parentMenu) {
      parentMenu.classList.add('submenu-open');
    }

    // Add the menu-opening class for animation
    details.classList.add('menu-opening');
    details.setAttribute('open', '');

    // Set aria-expanded for accessibility
    const summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }
  }

  // Function to close a submenu
  function closeSubmenu(details) {
    // Find the parent menu to remove the submenu-open class
    const parentMenu = details.closest('.submenu-open');
    if (parentMenu) {
      parentMenu.classList.remove('submenu-open');
    }

    // Remove classes and attributes
    details.classList.remove('menu-opening');

    // Add closing animation
    animateClose(details);

    // Set aria-expanded for accessibility
    const summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  // Function to animate the closing of a submenu
  function animateClose(details) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        details.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  // Run the fix after the page loads
  fixMobileMenu();

  // Also run after dynamic content loading (e.g., during AJAX)
  document.addEventListener('shopify:section:load', fixMobileMenu);
});